import React, { useEffect } from "react";
import Link from "next/link";

import { Action, Category } from "@/constants/events";
import { INITIAL_RESULT_LENGTH, SEARCH_INITIAL_TAKE } from "@/constants/search";
import { useEventTracker } from "@/hooks/useEventTracker";
import useSearch from "@/hooks/useSearch";

import Image from "@/components/Image";
import SearchViewMoreButton from "@/components/search/SearchViewMoreButton";
import Placeholder, { Rect } from "@/components/Skeleton";

const PLACEHOLDER_IMAGE =
  "https://public.leafly.com/consumer-web/brands/brand-placeholder.svg";

const BrandResults: React.FC = () => {
  const { brand, loading, searchCategory, searchTerm, loadMoreSearchResults } =
    useSearch();

  const { publishEvent } = useEventTracker();

  const isCategoryTab = searchCategory === "brand";

  useEffect(() => {
    if (isCategoryTab && brand.length === SEARCH_INITIAL_TAKE) {
      loadMoreSearchResults("brand", 7);
    }
  }, [isCategoryTab]);

  const brands = isCategoryTab ? brand : brand.slice(0, INITIAL_RESULT_LENGTH);

  return (
    <>
      <h2>Brands</h2>
      <p className="mb-lg">matching "{searchTerm}"</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-xl">
        {loading
          ? new Array(isCategoryTab ? 8 : INITIAL_RESULT_LENGTH)
              .fill(null)
              .map((_, i) => (
                <div key={`brand-card-placeholder-${i}`}>
                  <div>
                    <Placeholder
                      width="100%"
                      height="100%"
                      className="rounded-full overflow-hidden aspect-square"
                    >
                      <Rect width="100%" height="100%" />
                    </Placeholder>
                  </div>
                  <Placeholder
                    className="mx-auto mt-lg"
                    width="65%"
                    height="20"
                  >
                    <Rect width="100%" height="100%" />
                  </Placeholder>
                </div>
              ))
          : brands.map((brand) => (
              <Link
                data-testid="brand-coin__link"
                href={`/brands/${brand.slug}`}
                onClick={() =>
                  publishEvent({
                    action: Action.click,
                    brandId: brand.id,
                    category: Category.brandResults,
                    label: `brand quick access - ${brand.name}`,
                  })
                }
                className="block w-full"
                key={brand.id}
              >
                <Image
                  src={brand.logo || PLACEHOLDER_IMAGE}
                  alt={`${brand.name} logo`}
                  sizes={[233, 344, 166, 230, null, 233]}
                  ratio="square"
                  imgixParams={{ bg: "fff" }}
                  className="rounded-full shadow-low"
                />
                <div className="mt-md text-center text-green underline">
                  {brand.name}
                </div>
              </Link>
            ))}
      </div>

      <SearchViewMoreButton category="brand" />
    </>
  );
};

export default BrandResults;
